import apiCaller from 'util/apiCaller';

const fetchDanhMuc = function* fetchDanhMucHuyen(maDonVi) {
  let data = apiCaller(`api/dmdc/donvihanhchinhcapduoi?madonvi=${maDonVi}`, 'GET', null);
  return yield data ? data : [];
}

const fetchDanhMucById = function* fetchDanhMucById(maDonVi) {
  let data = apiCaller(`api/dmdc/donvihanhchinh?madonvi=${maDonVi}`, 'GET', null);
  return yield data ? data : [];
}

export const danhMucDungChungAPI = {
  fetchDanhMuc,
  fetchDanhMucById,
};